<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-02 14:31:01
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 16:46:31
-->
<template>
	<div class="bind-box flex-column flex-row-align-center flex-just-center">
		<div style="width: 308px">
			<p class="title mb-8">微信授权</p>
			<p class="sub-title">为保证后续能接收达人招商的查看、选品、申样等提醒必须微信授权后才可以进入系统</p>
			<el-image :src="xcx_qrcode" width="240" height="240" class="mt-20 mb-20"></el-image>
			<p class="sub-title">微信扫描二维码进行小程序授权</p>
			<div class="mt-12 flex flex-align-center flex-just-center">
				<a class="link font-h4-regular" href="#" @click="exit">退出登录</a>
				<template v-if="showChooseBtn">
					<span style="display: inline-block; width: 1px; height: 10px; background-color: #e2e3e8" class="ml-12 mr-12"></span>
					<a class="link font-h4-regular" href="#" @click="showChooseDialog">重新选择团队</a>
				</template>
			</div>
		</div>

		<!-- 切换团队弹窗 -->
		<ChooseGroup ref="chooseGroup" @choose="chooseGroup" :tenantInfoList="tenantInfoList" :tenantId="tenantInfo.id" />
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { checkBindWx, confirmLogin } from '@/api/user';
import { logout } from '@/api/user';
import router, { resetRoute } from '@/router';
import * as types from '@/store/mutation-types.js';
import wechatQrCodeImg from '@/mixins/wechatQrCodeImg';
import { getTenantList } from '@/api/businessGroup';
export default {
	mixins: [wechatQrCodeImg],
	data() {
		return {
			timer: null,
			tenantInfoList: [],
		};
	},
	computed: {
		...mapGetters(['tenantInfo']),
		...mapState(['vuex_userId']),
		showChooseBtn() {
			return this.tenantInfoList?.length > 1;
		},
		redirectUrl() {
			return decodeURIComponent(this.$route.query.redirectUrl || '');
		},
	},
	components: {
		ChooseGroup: () => import('@/components/business/chooseTenant'),
	},
	mounted() {
		this.initIMG();
		this.checkBindWx();
		this.switchAccount();
	},
	methods: {
		checkBindWx() {
			this.timer && clearInterval(this.timer);
			this.timer = setInterval(async () => {
				let params = {};
				if (this.host_app_key) {
					params.host_app_key = this.host_app_key;
				}
				const { data: { bind_status } = {} } = await checkBindWx(params);
				if (bind_status) {
					clearInterval(this.timer);
					this.$router.replace(this.redirectUrl ? this.redirectUrl : '/');
				}
			}, 5000);
		},
		async exit() {
			const { code } = await logout();
			if (code === 0) {
				utils.clearData();
			}
			// 登出之后回到登录页
			this.$router.replace('/login');
		},
		async switchAccount() {
			const { tenantInfoList } = await getTenantList({ userId: this.vuex_userId });
			this.tenantInfoList = tenantInfoList;
		},
		showChooseDialog() {
			this.$refs.chooseGroup.show();
		},
		// 选择团队
		async chooseGroup({ tenantId, userId, preAuthSign }) {
			const {
				code,
				data: { accessToken, roleList },
			} = await confirmLogin({ tenantId, userId, preAuthSign });
			if (code === 0) {
				this.handleTenantLogin({ accessToken, tenantId, roleList, userId });
				this.$refs.chooseGroup.hide();
			}
		},
		handleTenantLogin({ accessToken, roleList, tenantId, userId }) {
			// 保存token到cookie
			CookiesTools.setToken(accessToken);
			// 设置登录态
			this.$store.commit(types.LOGIN_STATUS, true);
			this.$store.commit(types.TENANT_ID, tenantId);
			this.$store.commit(types.BIND_ROLES, roleList);
			this.$store.commit(types.USER_ID, userId);
			this.$store.commit(types.CHANGE_READY, false);
			resetRoute(router);
			this.$router.replace(`/`);
		},
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
};
</script>
<style lang="less" scoped>
.bind-box {
	height: 100%;
	.title {
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: @color-text-primary;
		font-size: 18px;
		text-align: center;
	}
	.sub-title {
		font-size: 14px;
		color: @color-text-regular;
		line-height: 20px;
		text-align: center;
	}
}
a.link {
	cursor: pointer;
	color: @color-text-primary;
	&:hover {
		color: @color-primary;
		text-decoration: none;
	}
}
.mt-40 {
	margin-top: 40px;
}
</style>
